import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useToeBoardExtrasApi } from "../../../../../http/border/useToeBoardExtras";
import ToeBoardExtraForm from "./ToeBoardExtraForm";

interface EditToeBoardExtraProps {
  onClose: () => void;
  toeBoardExtraId: string;
}

const EditToeBoardExtra: FC<EditToeBoardExtraProps> = ({ onClose, toeBoardExtraId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const toeBoardExtrasApi = useToeBoardExtrasApi();

  const { data, error, trigger } = toeBoardExtrasApi.getAdminToeBoardExtra(toeBoardExtraId, aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    toeBoardExtraId && trigger();
  }, [toeBoardExtraId]);

  return <ToeBoardExtraForm onClose={onClose} toeBoardExtra={data} isDisabled={!!error} isLoading={!data && !error} />;
};

export default EditToeBoardExtra;
